'use client';

import { useDAL } from '@/contexts/useDAL';

import { DbClusterParameterGroupSelect } from './dbClusterParameterGroupSelect';

export const NeptuneParameterGroupSelect = ({
  accountId,
  regionName,
  parameterGroupName,
  onChange,
}: {
  accountId?: string;
  regionName?: string;
  parameterGroupName?: string;
  onChange: (name: string) => void;
}) => {
  const dal = useDAL();

  return (
    <DbClusterParameterGroupSelect
      accountId={accountId}
      regionName={regionName}
      parameterGroupName={parameterGroupName}
      onChange={onChange}
      useList={dal.restore.neptuneParameterGroups.useList}
      engineLabel='Neptune'
      testId='neptuneParameterGroupSelect'
    />
  );
};
